import React from 'react'
import {Mutation, Query, graphql} from 'react-apollo'
import {
  Typography,
  IconButton,
  CircularProgress,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Icon,
} from '@material-ui/core'
import {toast} from 'react-toastify'
import DeleteIcon from '@material-ui/icons/Delete'
import DialogConfirmation from '../../../utils/DialogConfirmation'
import {
  EDIT_MEMBER,
  DELETE_MEMBER,
  GENERATE_NOTIFICATION_KEY,
  REMOVE_LINE_NOTIFICATION,
} from '../../../../../graphql/mutation'
import {MEMBERS} from '../../../../../graphql/query'

class EditMemberComponent extends React.Component {
  state = {
    isShowDeleteModal: false,
    deleteMemberId: null,
    isLoading: false,
  }

  handleRoleChange = async (e, member, editMember) => {
    const {value} = e.target
    await editMember({
      variables: {
        projectId: this.props.project.id,
        id: member.id,
        role: value,
      },
    })
  }

  onDeleteModalCancel = () => {
    this.setState(() => ({
      isShowDeleteModal: false,
      isLoading: false,
    }))
  }

  onDeleteModalConfirm = async () => {
    try {
      this.setState(() => ({
        isLoading: true,
      }))
      await this.props.mutate({
        variables: {
          projectId: this.props.project.id,
          id: this.state.deleteMemberId,
        },
        refetchQueries: [
          {
            query: MEMBERS,
            variables: {projectId: this.props.project.id},
          },
        ],
      })
      toast.success('Member is deleted', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
    } catch (e) {
      toast.error(`Can't delete member ${JSON.stringify(e)}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
    }
    this.setState(() => ({
      isShowDeleteModal: false,
      isLoading: false,
    }))
  }

  onClickMemberDeleteButton = deleteMemberId => {
    this.setState(() => ({
      isShowDeleteModal: true,
      isLoading: false,
      deleteMemberId,
    }))
  }

  render() {
    return (
      <div>
        <React.Fragment>
          <DialogConfirmation
            isLoading={this.state.isLoading}
            open={this.state.isShowDeleteModal}
            handleConfirm={this.onDeleteModalConfirm}
            handleClose={this.onDeleteModalCancel}
            title="Are you sure to remove this member from the project?"
            action="Remove"
          />
          <Typography variant="title">Project Members</Typography>
          <Query query={MEMBERS} variables={{projectId: this.props.project.id}}>
            {({loading, error, data}) => (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Email</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell style={{width: '200px'}}>
                      Chat Name / Key (key will be expired in 5 minutes)
                    </TableCell>
                    <TableCell>Remove</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    ((data && data.members) || []).map((row, i) => {
                      return (
                        <TableRow key={i}>
                          <TableCell>{row.email}</TableCell>

                          <TableCell>
                            <Mutation mutation={EDIT_MEMBER}>
                              {editMember => (
                                <Select
                                  name={String(i)}
                                  value={row.role}
                                  onChange={e =>
                                    this.handleRoleChange(e, row, editMember)
                                  }
                                >
                                  <MenuItem value="owner">Owner</MenuItem>
                                  <MenuItem value="admin">Admin</MenuItem>
                                </Select>
                              )}
                            </Mutation>
                          </TableCell>
                          <TableCell>
                            <Mutation mutation={GENERATE_NOTIFICATION_KEY}>
                              {(generateKey, result) => {
                                if (row.isEnableNotification && row.lineName) {
                                  return (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <span>{row.lineName} </span>
                                      <Mutation
                                        mutation={REMOVE_LINE_NOTIFICATION}
                                        refetchQueries={_re => {
                                          return [
                                            {
                                              query: MEMBERS,
                                              variables: {
                                                projectId: this.props.project
                                                  .id,
                                              },
                                            },
                                          ]
                                        }}
                                      >
                                        {removeLineNotification => {
                                          return (
                                            <Icon
                                              onClick={async () => {
                                                await removeLineNotification({
                                                  variables: {
                                                    projectId: this.props
                                                      .project.id,
                                                    permissionId: row.id,
                                                  },
                                                })
                                              }}
                                              style={{
                                                fontSize: '15px',
                                                color: '#a3a3a3',
                                                cursor: 'pointer',
                                              }}
                                            >
                                              remove_circle
                                            </Icon>
                                          )
                                        }}
                                      </Mutation>
                                    </div>
                                  )
                                }
                                if (
                                  result.data &&
                                  result.data.generateOTP.userId === row.userId
                                ) {
                                  return (
                                    <span style={{color: '#a3a3a3'}}>
                                      {result.data.generateOTP.OTP}
                                    </span>
                                  )
                                }
                                return (
                                  <span
                                    style={{
                                      color: '#663EE8',
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                    }}
                                    onClick={async () => {
                                      await generateKey({
                                        variables: {
                                          userId: row.userId,
                                          projectId: this.props.project.id,
                                        },
                                      })
                                    }}
                                  >
                                    generate key
                                  </span>
                                )
                              }}
                            </Mutation>
                          </TableCell>
                          <TableCell>
                            <React.Fragment>
                              <IconButton
                                onClick={() =>
                                  this.onClickMemberDeleteButton(row.id)
                                }
                              >
                                <DeleteIcon />
                              </IconButton>
                            </React.Fragment>
                          </TableCell>
                        </TableRow>
                      )
                    })
                  )}
                </TableBody>
              </Table>
            )}
          </Query>
        </React.Fragment>
      </div>
    )
  }
}

export default graphql(DELETE_MEMBER)(EditMemberComponent)



// WEBPACK FOOTER //
// ./src/main/content/project/settings/components/EditMemberComponent.js